<div mat-dialog-content>
    <img [src]="data.url">
</div>
<div mat-dialog-actions align="end">
    <a mat-button mat-dialog-close (click)="close()"><i class="fas fa-times"></i></a>
</div>
